import PrimaryButton from 'components/buttons/PrimaryButton';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SuccessButton: FunctionComponent<Props> = ({
    className = '',
    isDisabled,
    onClick,
    testId = TEST_ID,
    text
}) => (
    <PrimaryButton
        className={`${styles.button} ${className}`}
        isDisabled={isDisabled}
        onClick={onClick}
        testId={testId}
        text={text}
    />
);

export default SuccessButton;
